export default __webpack_public_path__ + "static/media/logo.297a5041.svg";